import getSpamScenarioStore from '../selectors/getSpamScenarioStore';
import { SpamScenarioId } from 'owa-junkmail-configuration';

export default function getSpamList(scenarioId: SpamScenarioId) {
    const optionState = getSpamScenarioStore(scenarioId);
    return optionState.spamList;
}
